/**
 * 教师端静态路由（直接写入 Vue Router，不请求 getRouters）
 * 菜单范围与 config/teacherStaticRouters.js 一致
 */

import template from "@/views/Layout/template.vue";
import Home from "@/views/home/index.vue";
import Course from "@/views/Course/index";
import QuestionBank from "@/views/QuestionBank/index";
import Knowledge from "@/views/Knowledge/index";
import News from "@/views/News/index";

export const TEACHER_DEFAULT_ROUTE = "/home";

/** 教师端业务路由（挂到 Layout children） */
export const teacherStaticRoutes = [
  {
    name: "首页",
    path: "/home",
    component: Home,
    meta: { title: "首页", requireAuth: true }
  },
  {
    name: "课程管理",
    path: "/course",
    component: Course,
    meta: { title: "课程管理", requireAuth: true }
  },
  {
    name: "题库管理",
    path: "/question",
    component: template,
    meta: { title: "题库管理", requireAuth: true },
    children: [
      {
        path: "theory",
        name: "理论题库",
        component: QuestionBank,
        meta: { title: "理论题库", requireAuth: true }
      },
      {
        path: "practical",
        name: "实操题库",
        component: QuestionBank,
        meta: { title: "实操题库", requireAuth: true }
      }
    ]
  },
  {
    name: "知识库",
    path: "/Knowledge",
    component: Knowledge,
    meta: { title: "知识库", requireAuth: true }
  },
  {
    name: "新闻管理",
    path: "/news",
    component: News,
    meta: { title: "新闻管理", requireAuth: true }
  }
];

export default teacherStaticRoutes;



// WEBPACK FOOTER //
// ./src/router/teacherStaticRoutes.js